<section class="invoice-concepts">
  <!-- Header -->
  <header class="invoice-concepts__header">
    <div class="invoice-concepts__title">
      <span class="invoice-concepts__icon"><lib-icon [name]="config().icon"></lib-icon></span>
      <span>{{ config().title | translate }}</span>
      @if(hasCounter()) {<span class="invoice-concepts__count">{{data().length}}</span>}
    </div>
    @if(hasAction() && actionsHeader()){ @for (item of actionsHeader(); track item) {
    <lib-button (clicked)="(sendAction(item.id))" [prefixIcon]="item.icon">
      {{item.label |translate}}</lib-button
    >}}
  </header>
  @if(data().length >0 && config().components.columns.length >0) {
  <!-- Table -->
  <div class="invoice-table">
    <!-- Table header -->
    <div class="invoice-table__header">
      <div class="invoice-table__cell">
        <div
          [style.display]="'flex'"
          [style.flex-direccion]="'row'"
          [style.width]="hasAction() ? '90%' : '100%'"
        >
          @for (col of config().components.columns; track col) {
          <span [style.width]="col.width">{{col.label | translate |uppercase }}</span>
          }
        </div>
        @if(hasAction()){
        <div class="btn-delete"></div>
        }
      </div>
    </div>

    <!-- Row -->
    <div class="invoice-table__body">
      @for (row of data(); track row) {

      <div class="invoice-table__row">
        <div class="campos" [style.width]="hasAction() ? '90%' : '100%'">
          @for (col of config().components.columns; track col.key) {

          <div [class]=" col.double ? 'concept':'input-wrapper'" [style.width]="col.width">
            <div [class]=" col.badge ? 'concept__title':'' ">
              @if(col.badge) {<span class="concept__code">{{getValue(row, col.badge)}}</span>}
              @switch (col.type) { @case ('text') {

              <span> {{ getValue(row, col.key) }} </span>

              } @case ('number') {
              <lib-input
                [value]="getValue(row, col.key)?? 0"
                [placeholder]="col.placeholder ?? '' | translate"
                [readonly]="col.readonly"
                (valueChange)="sendChangeData(row, col.key,data().indexOf(row),$event)"
              />
              } @case ('currency') {
              <lib-input
                [value]="getValue(row, col.key) ?? 0 "
                [placeholder]="col.placeholder ?? '' | translate"
                [readonly]="col.readonly"
                (valueChange)="sendChangeData(row, col.key,data().indexOf(row),$event)"
              />
              } @case ('search') {

              <lib-input
                [value]="getValue(row, col.key)"
                [placeholder]="col.placeholder ?? '' | translate"
                [readonly]="true"
                [actionIcon]="'Search'"
                (action)="sendSearchInput(row, col.key,data().indexOf(row))"
              />

              } @case ('total') {

              <div class="input-wrapper__total">
                <strong> {{ getValue(row, col.key) ?? 0 | currency: 'COP' }} </strong>
              </div>

              } }
            </div>
            @if(col.double && col.doubleConfig ) {
            <div class="concept__detail">
              @if(col.doubleConfig.badge ) {
              <span>
                {{col.doubleConfig.searcheable ? getValue(row, col.doubleConfig.badge) :
                col.doubleConfig.label |translate }} </span
              >}
              <div class="input-small">
                @if(col.doubleConfig.readonly === true) {<span
                  >{{col.doubleConfig.label |translate}} - {{getValue(row, col.doubleConfig.key)}} </span
                >} @else {
                <lib-input
                  [value]="getValue(row, col.doubleConfig.key)"
                  [placeholder]="col.doubleConfig.placeholder ?? '' | translate"
                  [readonly]="col.doubleConfig.searcheable"
                  [actionIcon]="col.doubleConfig.searcheable ? 'Search': undefined"
                  (action)="sendSearchInput(row, col.doubleConfig.key,data().indexOf(row))"
                  [required]="true"
                  (valueChanges)="sendChangeData(row, col.key,data().indexOf(row),$event)"
                />}
              </div>
            </div>
            }
          </div>
          }
        </div>
        @if(hasAction() && actionsBody()){
        <div class="btn-delete">
          @for (item of actionsBody(); track item) {
          <lib-button
            [prefixIcon]="item.icon"
            [ariaLabel]="item.label"
            variant="icon-ghost"
            (clicked)="sendAction(item.id,data().indexOf(row))"
          >
          </lib-button
          >}
        </div>
        }
      </div>

      }
    </div>
  </div>
  }

  <!-- Summary -->
  <footer class="invoice-summary">
    @if (hasSummary()) {
    <div class="invoice-summary__item">
      <span>SUBTOTAL</span>
      <strong>$ 0</strong>
    </div>

    <div class="invoice-summary__item">
      <span>DEDUCCIONES</span>
      <strong>- $ 0</strong>
    </div>

    <div class="invoice-summary__item">
      <span>IMPUESTOS</span>
      <strong>+ $ 0</strong>
    </div>

    <div class="invoice-summary__item invoice-summary__item--total">
      <span>TOTAL FACTURA</span>
      <strong>$0</strong>
    </div>
    }
  </footer>
</section>
